module.exports = __webpack_public_path__ + "img/TOC_Arrow.09487993.png";